// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"144":"22694fb7","422":"335061f5","977":"c117eb84"}[chunkId] + ".chunk.js");